import { EditButton, ReferenceManyField, Show, ShowActionsProps, ShowProps, Tab, TabbedShowLayout, TopToolbar, usePermissions } from "react-admin";
import { NotesList } from "../note/notes-list";
import { OrdersLink, ShowTitle, SubscriptionsLink } from "../shared-components";
import { DriverFields } from "./driver-fields";
import { verifyAccess } from "../../utils/resourcePermissons"

const DriverShowActions = ({ basePath, data }:ShowActionsProps) => {
  const { permissions } = usePermissions()
  return (
    <TopToolbar>
      <OrdersLink href={`https://backoffice.gopuff.com/orders?driver_id=${data?.rails_id}`}/>
      <SubscriptionsLink href={`https://backoffice.gopuff.com/subscriptions?user_id=${data?.rails_id}`}/>
      {verifyAccess(permissions, 'driver', 'update') ? <EditButton basePath={basePath} record={data} /> : null}       
    </TopToolbar>
  )
};

export const DriverShow: React.FC<ShowProps> = (props) => (
  <Show title={<ShowTitle/>} actions={<DriverShowActions />} {...props}>
    <TabbedShowLayout>
      <Tab label="Driver info">
        <DriverFields {...props} />
      </Tab>
      {/* <Tab label="Devices" path="devices">
        <ReferenceManyField reference="devices" target="user_id" filter={{ user_id: props.id }} addLabel={false}>
          <AddressList/>
        </ReferenceManyField>
      </Tab> */}
      { isNaN(Number(props.id)) ? 
        (<Tab label="Notes & Audit logs" path="notes">
          <ReferenceManyField reference="notes" target="user_id" filter={{ id: props.id }} addLabel={false} {...props}>
            <NotesList {...props} />
          </ReferenceManyField>
        </Tab>) : null 
      }
    </TabbedShowLayout>
  </Show>
);

